// LoginStyles.js
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'ABC Social Bold';
    font-display: swap;
    src: url('https://static.eurostar.com/shared/fonts/ABCSocial-Bold.woff2') format('woff2');
  }
  
  @font-face {
    font-family: 'ABC Social Regular';
    font-display: swap;
    src: url('https://static.eurostar.com/shared/fonts/ABCSocial-Regular.woff2') format('woff2');
}

*, *::before, *::after {
    box-sizing: border-box;
  }
`;

export const LoginContainer = styled.div`
  height: 100%;
  position: relative;
`;

export const LoginBox = styled.div`
  background-color: #ffffff;
  border-radius: 5px;
  border-top: 1px solid #e9e9e9;
  box-shadow: 0px 5px 5px #cccccc;
  padding: 0;
  position: absolute;
  top: 25%;
  left: 0;
  right: 0;
  max-width: 500px;
  margin: 100px auto;
`;

export const LoginHeader = styled.div`
  text-align: center;
  background-color: #ffffff;
  border-radius: 5px 5px 0 0;
`;

export const LogoContainer = styled.div`
  align-content: center;
  justify-content: center;
  display: flex;
  padding: 30px 15px 15px 15px;
  position: relative;
`;

export const LoginContent = styled.div`
  padding: 15px;
  position: relative;
  width: auto;
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
  width: auto;
`;

export const FormControl = styled.input`
  border: 1px solid #c8c8c7;
  border-radius: 0.25rem;
  font-size: 1rem;
  height: 1rem;
  padding: 1.2rem 1rem;
  transition: border 300ms ease;
  width: 100%;

  &:hover {
    border: 1px solid #646463;
  }

  &:focus,
  &:focus-within,
  &:focus-visible {
    border: 1px solid #106dff;
    box-shadow: none;
    outline: none;
  }
`;

export const LoginButton = styled.button`
  background-color: #ffc305;
  border: 1px solid transparent;
  color: #1c1c1a;
  font-size: 1rem;
  height: 40px;
  width: 76px;
  cursor: pointer;

  &:hover {
    background-color: #cc9c04;
    border-color: transparent;
    color: #1c1c1a;
  }

  &:focus {
    background-color: #ffc305;
    border-color: #1c1c1a;
    color: #1c1c1a;
    outline: none;
  }

  &:active,
  &:active:hover,
  &:active:focus {
    background-color: #997503;
    border-color: transparent;
    color: #1c1c1a;
    outline: none;
  }

  &:disabled,
  &[disabled]:hover {
    background-color: #e3e3e3;
    border-color: transparent;
    color: #646463;
  }
`;

export const ResetLink = styled.a`
  background-color: transparent;
  color: #062c66;
  cursor: pointer;
  display: block;
  margin-bottom: 24px;
  text-decoration: underline;
`;

export const ErrorMessage = styled.div`
  display: block;
  color: red;

  p {
    color: inherit;
  }
`;

export const ErrorText = styled.span`
  color: red;
  font-size: 0.875rem;
`;
